import { createWebHistory, createRouter } from "vue-router";

import Login from "../views/Login.vue";
import { ROUTES } from "@/const.js";

const routes = [
  {
    ...ROUTES.get("LOGIN"),
    component: Login,
    props: true,
  },
  {
    ...ROUTES.get("SIGN_UP"),
    component: () => import("../views/SignUp.vue"),
  },
  {
    ...ROUTES.get("SIGN_UP_SUCCESS"),
    component: () => import("../views/SignUpSuccess.vue"),
  },
  {
    ...ROUTES.get("FORGOT_PASSWORD"),
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    ...ROUTES.get("RESET_PASSWORD"),
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    ...ROUTES.get("EXTERNAL_AUTH"),
    component: () => import("../views/ExternalAuth.vue"),
  },
  {
    ...ROUTES.get("NOT_FOUND"),
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
